import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { useTranslation } from 'react-i18next';
import {
  userPreferencesState,
  currentViewNameState,
  setFilteredColumns,
} from '../TicketListSlice';
import { userInfoState } from '../../HomeSlice';
import useStyles from './styles';

export default function SettingPopUp(props) {
  const { openSetting } = props;

  const currentViewName = useSelector(currentViewNameState);
  const userPreferences = useSelector(userPreferencesState);
  const column = userPreferences.find(
    (userPreference) => userPreference.viewName === currentViewName,
  ).filteredColumns;
  const user = useSelector(userInfoState);
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleClose = () => {
    props.setOpenSettingState(false);
  };

  const handleChange = (event) => {
    const filteredColumnsForView = {};
    filteredColumnsForView.filteredColumns = {
      ...column,
      [event.target.name]: event.target.checked,
    };
    filteredColumnsForView.viewName = currentViewName;
    dispatch(setFilteredColumns(filteredColumnsForView));
  };

  const isColumnVisible = () => {
    return user.internal || user.hasEmilyDRights || user.externalMax;
  };

  return (
    <Dialog open={openSetting} onClose={handleClose}>
      <DialogContent className={classes.dialog}>
        <DialogTitle className={classes.title}>
          <FormLabel className={classes.label}>
            {t('table_attributes_selection')}
          </FormLabel>
        </DialogTitle>
        <Divider />

        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={column.ticketNumber}
                onChange={handleChange}
                name="ticketNumber"
              />
            }
            label={
              <Typography className={classes.label}>
                {t('Ticket ID')}
              </Typography>
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={column.wagonNumber}
                onChange={handleChange}
                name="wagonNumber"
              />
            }
            label={
              <Typography className={classes.label}>{t('Wagon')}</Typography>
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={column.ticketCreator}
                onChange={handleChange}
                name="ticketCreator"
              />
            }
            label={
              <Typography className={classes.label}>
                {t('Ticket creator')}
              </Typography>
            }
          />
          {isColumnVisible() && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={column.plannedType}
                  onChange={handleChange}
                  name="plannedType"
                />
              }
              label={
                <Typography className={classes.label}> {t('Type')}</Typography>
              }
            />
          )}
          {isColumnVisible() && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={column.ticketStatus}
                  onChange={handleChange}
                  name="ticketStatus"
                />
              }
              label={
                <Typography className={classes.label}>
                  {t('Ticket status')}
                </Typography>
              }
            />
          )}
          {isColumnVisible() && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={column.businessUnit}
                  onChange={handleChange}
                  name="businessUnit"
                />
              }
              label={
                <Typography className={classes.label}>
                  {t('Business unit')}
                </Typography>
              }
            />
          )}
          {isColumnVisible() && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={column.lastAnomalyDate}
                  onChange={handleChange}
                  name="lastAnomalyDate"
                />
              }
              label={
                <Typography className={classes.label}>
                  {t('Last anomaly')}
                </Typography>
              }
            />
          )}

          {isColumnVisible() && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={column.wagonStatus}
                  onChange={handleChange}
                  name="wagonStatus"
                />
              }
              label={
                <Typography className={classes.label}>
                  {t('Wagon status')}
                </Typography>
              }
            />
          )}

          <FormControlLabel
            control={
              <Checkbox
                checked={column.loadedStatus}
                onChange={handleChange}
                name="loadedStatus"
              />
            }
            label={
              <Typography className={classes.label}>
                {t('Loaded status')}
              </Typography>
            }
          />

          {isColumnVisible() && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={column.priority}
                  onChange={handleChange}
                  name="priority"
                />
              }
              label={
                <Typography className={classes.label}>
                  {t('Priority')}
                </Typography>
              }
            />
          )}

          <FormControlLabel
            control={
              <Checkbox
                checked={column.damageCodes}
                onChange={handleChange}
                name="damageCodes"
              />
            }
            label={
              <Typography className={classes.label}>
                {t('Damage codes')}
              </Typography>
            }
          />

          {isColumnVisible() && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={column.damagePlace}
                  onChange={handleChange}
                  name="damagePlace"
                />
              }
              label={
                <Typography className={classes.label}>
                  {t('Damage place')}
                </Typography>
              }
            />
          )}

          {isColumnVisible() && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={column.siteConcerned}
                  onChange={handleChange}
                  name="siteConcerned"
                />
              }
              label={
                <Typography className={classes.label}>
                  {t('Site concerned')}
                </Typography>
              }
            />
          )}
          <FormControlLabel
            control={
              <Checkbox
                checked={column.keeper}
                onChange={handleChange}
                name="keeper"
              />
            }
            label={
              <Typography className={classes.label}> {t('Keeper')}</Typography>
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={column.productType}
                onChange={handleChange}
                name="productType"
              />
            }
            label={
              <Typography className={classes.label}>
                {t('Product type')}
              </Typography>
            }
          />
          {isColumnVisible() && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={column.origin}
                  onChange={handleChange}
                  name="origin"
                />
              }
              label={
                <Typography className={classes.label}>{t('Origin')}</Typography>
              }
            />
          )}

          <FormControlLabel
            control={
              <Checkbox
                checked={column.labelWagon}
                onChange={handleChange}
                name="labelWagon"
              />
            }
            label={
              <Typography className={classes.label}>
                {t('Label wagon')}
              </Typography>
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={column.appliedLabel}
                onChange={handleChange}
                name="appliedLabel"
              />
            }
            label={
              <Typography className={classes.label}>
                {t('Applied label')}
              </Typography>
            }
          />
          {isColumnVisible() && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={column.nextRevisionDate}
                  onChange={handleChange}
                  name="nextRevisionDate"
                />
              }
              label={
                <Typography className={classes.label}>
                  {t('Next revision')}
                </Typography>
              }
            />
          )}

          {isColumnVisible() && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={column.assignedWorkshop}
                  onChange={handleChange}
                  name="assignedWorkshop"
                />
              }
              label={
                <Typography className={classes.label}>
                  {t('Assigned workshop')}
                </Typography>
              }
            />
          )}
        </FormGroup>
      </DialogContent>
    </Dialog>
  );
}
